import { GetStage } from '../../draft/utils/stageUtils';
import {Tournament, Participant, Game} from '../types'


export const ApplyVictory = (
    inputTournament:Tournament, 
    gameID : string,
    winner: ('blue'|'red'),
    stockDifference:number
):Tournament => {
    let newTour = Object.assign({}, inputTournament);
    
    const temp = newTour.GroupStageGames.find((g) => g.Id === gameID)
    if(!temp) throw new Error();

    if(winner === 'blue' ){
        temp.Winners = temp.TeamBlue
        newTour = UpdatePlayers(newTour, temp.TeamRed, 0, -stockDifference, 1);

    }

    if(winner === 'red' ){
        temp.Winners = temp.TeamRed
        newTour = UpdatePlayers(newTour, temp.TeamBlue, 0, -stockDifference, 1);

    }

    newTour = UpdatePlayers(newTour, temp.Winners, 1, stockDifference, 1);
    temp.StockDifference = stockDifference;
    
    return newTour;
}

export const Revertgame = (inputTournament:Tournament, gameID : string):Tournament => {
    let updatedTour = Object.assign({}, inputTournament);
    const game = updatedTour.GroupStageGames.find((g) => g.Id === gameID)
    if(!game || game.Winners.length === 0 || !game.StockDifference) throw new Error();

    const winners = game.Winners;
    updatedTour = UpdatePlayers(updatedTour, winners, -1, -game.StockDifference, -1)

    const loosers = game.Players.filter((p) => !winners.some((t) => t.Number === p.Number));
    updatedTour = UpdatePlayers(updatedTour, loosers, 0, game.StockDifference, -1)

   
    game.Winners = []
    game.StockDifference = undefined;

    return updatedTour;
}

const UpdatePlayers = (
    tournament: Tournament,
    targetPlayers : Participant[], 
    wins:number, 
    stockDifference:number,
    gamesPlayed : number
) => {
    let updatedTour = Object.assign({}, tournament);

    targetPlayers.forEach((i) => {
        const temp = updatedTour.Players.find((j) => i.Number === j.Number);
        if(temp){
            temp.StockDifference += stockDifference;
            temp.Wins += wins;
            temp.GamesPlayed += gamesPlayed;
        }
    })

    return updatedTour;
}

export const UpdateGameDraft = (
    tournament : Tournament,
    game : Game,
    stage : string,
    updatedParticipants : Participant[]
) => {
    let updatedTour = Object.assign({}, tournament);
    updatedTour.GroupStageGames.forEach(g => {
        if(g.Id === game.Id){
            const fetchedStage = GetStage(stage, tournament.DraftOptions.gameType, tournament.DraftOptions.stagePack);
            if(fetchedStage)
                g.Stage = fetchedStage

            updatedParticipants.forEach((i) => {
                const temp = g.Players.find((j) => i.Number === j.Number);
                if(temp){
                    temp.Hero = i.Hero
                }
            })
        }
    })

   
    return updatedTour;
}